import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = [
    "PurchaseOrderIdsInput",
    "ShippingOptions", "SelectedShippingOption", "ShippingOptionValidationMessage",
    "TruckTypeDryVanInput", "TruckTypeFlatbedInput", "TruckTypeHopperBottomInput",
    "TotalWeightInput", "NumPalletsInput",
    "PickupDateTypeAsapInput", "PickupDateTypeSpecificInput", "PickupDateSelection", "PickupDateInput",
    "SupplierNameInput", "SupplierStreetInput", "SupplierCityInput", "SupplierStateInput", "SupplierZipInput", "SupplierEmailInput", "SupplierPhoneInput", "SupplierBusinessTypeBusinessInput", "SupplierBusinessTypeFarmInput", "SupplierLoadingOptionLoadingDockInput", "SupplierLoadingOptionForkliftInput", "SupplierLoadingOptionNoneInput",
    "CustomerNameInput", "CustomerCompanyInput", "CustomerStreetInput", "CustomerCityInput", "CustomerStateInput", "CustomerZipInput", "CustomerEmailInput", "CustomerPhoneInput", "CustomerBusinessTypeBusinessInput", "CustomerBusinessTypeFarmInput", "CustomerLoadingOptionLoadingDockInput", "CustomerLoadingOptionForkliftInput", "CustomerLoadingOptionPalletJackInput", "CustomerLoadingOptionNoneInput",
    "BolBlindOriginTypeNoInput", "BolBlindOriginTypeYesInput", "BolBlindOriginInput", "BolBlindOriginDetailsContainer", "BolBlindOriginNameInput", "BolBlindOriginStreetInput", "BolBlindOriginCityInput", "BolBlindOriginStateInput", "BolBlindOriginZipInput",
    "BolBlindDestinationTypeNoInput", "BolBlindDestinationTypeYesInput", "BolBlindDestinationInput", "BolBlindDestinationDetailsContainer", "BolBlindDestinationNameInput", "BolBlindDestinationStreetInput", "BolBlindDestinationCityInput", "BolBlindDestinationStateInput", "BolBlindDestinationZipInput",
    "PurchaseOrderNumberInput", "BolNotesInput"
  ];

  connect() {
    this.element[this.identifier] = this

    this.initSupplierValues()
    this.initPickupDateVisibility()

    this.element.addEventListener("change", (e) => {
      if (e.target.getAttribute("data-truckload-shipment-target") === "ShippingOption") {
        this.SelectedShippingOptionTarget.value = e.target.value;
      }
    });
  }

  initSupplierValues() {
    this.SupplierNameInputTarget.value = "Dakota Ag Pro";
    this.SupplierStreetInputTarget.value = "405 N Hooker Ave";
    this.SupplierCityInputTarget.value = "White";
    this.SupplierStateInputTarget.value = "SD";
    this.SupplierZipInputTarget.value = "57276";
    this.SupplierEmailInputTarget.value = "dakagpro@outlook.com";
    this.SupplierPhoneInputTarget.value = "605-695-5545";
  }

  initPickupDateVisibility() {
    if (this.PickupDateTypeAsapInputTarget.checked) {
      this.PickupDateSelectionTarget.classList.add("hidden")
    }
  }

  handlePoSelect(po) {
    let existingPoIds = this.PurchaseOrderIdsInputTarget.value.split(",").filter((id) => id !== "");

    if (!existingPoIds.includes(po.id.toString())) {
      existingPoIds = existingPoIds.concat(po.id);
      this.PurchaseOrderIdsInputTarget.value = existingPoIds.join(",");

      const shippingOption = `
      <div class="rounded border-2 border-gray-300 p-4 mb-4 flex" id="shipping_option_po_id_${po.id}">
        <input type="radio" name="selected_shipping_option" id="shipping_option_${po.id}" value="${po.id}" data-truckload-shipment-target="ShippingOption" data-action="change->truckload-shipment#onPOSelectChange" required>
        <label for="shipping_option_${po.id}" class="ml-2">
          <div><strong>PO: </strong>${po.number}</div>
          <div><strong>Name: </strong>${po.customer_name}</div>
          <div><strong>Address: </strong>${po.order.shipping_address}, ${po.order.shipping_city}, ${po.order.shipping_state} ${po.order.shipping_zipcode}</div>
          <div><strong>Email: </strong>${po.order.email}</div>
          <div><strong>Phone: </strong>${po.order.phone_number}</div>
        </label>
        <button class="ml-2 text-red-500 text-sm" data-action="click->truckload-shipment#onPOCardRemove" data-purchase-order-id="${po.id}">Remove</button>
      </div>
    `;

    this.ShippingOptionsTarget.insertAdjacentHTML("beforeend", shippingOption);
    }

    if (this.PurchaseOrderIdsInputTarget.value.split(",").length == 1) {
      this.ShippingOptionsTarget.querySelector(`#shipping_option_${po.id}`).checked = true;
      this.onPOSelectChange({ currentTarget: { value: po.id } });
    }
  }

  onPOCardRemove(e) {
    const purchaseOrderId = e.currentTarget.dataset.purchaseOrderId;
    const poCard = this.ShippingOptionsTarget.querySelector(`#shipping_option_po_id_${purchaseOrderId}`)
    poCard.remove()

    const updatedPoIds = this.PurchaseOrderIdsInputTarget.value.split(",").filter((id) => id !== purchaseOrderId.toString());
    this.PurchaseOrderIdsInputTarget.value = updatedPoIds.join(",");
  }

  async onPOSelectChange(e) {
    const purchaseOrderId = e.currentTarget.value

    const response = await fetch(`/admin/purchase_orders/${purchaseOrderId}`, {
      headers: { Accept: "application/json" },
    });
    const data = await response.json();
    console.log('data', data)

    this.fillValuesFromPo(data)
  }

  handleSupplierSelect(supplier) {
    console.log("supplier: ", supplier);
    this.SupplierNameInputTarget.value = supplier.name;
    this.SupplierStreetInputTarget.value = supplier.address;
    this.SupplierCityInputTarget.value = supplier.city;
    this.SupplierStateInputTarget.value = supplier.state;
    this.SupplierZipInputTarget.value = supplier.zipcode;
    this.SupplierEmailInputTarget.value = supplier.email;
    this.SupplierPhoneInputTarget.value = supplier.phone_number;
    if (supplier.business_type == "business") {
      this.SupplierBusinessTypeBusinessInputTarget.checked = true;
    } else {
      this.SupplierBusinessTypeFarmInputTarget.checked = true;
    }
    if (supplier.loading_option == "loading_dock") {
      this.SupplierLoadingOptionLoadingDockInputTarget.checked = true;
    } else if (supplier.loading_option == "forklift") {
      this.SupplierLoadingOptionForkliftInputTarget.checked = true;
    } else {
      this.SupplierLoadingOptionNoneInputTarget.checked = true;
    }
  }

  fillValuesFromPo(po) {
    let truckType, totalWeight, toteSize, numPallets, poId

    this.PurchaseOrderNumberInputTarget.value = po.number

    // if order.selected_truckload_rate.present?
    if (po.order && po.order.selected_truckload_rate) {
      truckType = po.order.selected_truckload_rate.truck_type;
      console.log('truckType', truckType)
      if (truckType === "Dry Van") {
        this.TruckTypeDryVanInputTarget.checked = true;
        this.NumPalletsInputTarget.classList.remove('hidden');
      } else if (truckType == "Tarped Flatbed") {
        this.TruckTypeFlatbedInputTarget.checked = true;
        this.NumPalletsInputTarget.classList.remove('hidden');
      } else {
        this.TruckTypeHopperBottomInputTarget.checked = true;
        this.NumPalletsInputTarget.value = "";
        this.NumPalletsInputTarget.classList.add('hidden');
      }
    }

    // if order.present?
    if (po.order) {
      totalWeight = po.order.order_items[0].quantity;
      this.TotalWeightInputTarget.value = totalWeight;

      this.CustomerNameInputTarget.value = po.order.shipping_name;
      this.CustomerCompanyInputTarget.value = po.order.company_name;
      this.CustomerStreetInputTarget.value = po.order.shipping_address;
      this.CustomerCityInputTarget.value = po.order.shipping_city;
      this.CustomerStateInputTarget.value = po.order.shipping_state;
      this.CustomerZipInputTarget.value = po.order.shipping_zipcode;
      this.CustomerPhoneInputTarget.value = po.order.phone_number;
      this.CustomerEmailInputTarget.value = po.order.email;

      if (po.order.destination_business_type == "business") {
        this.CustomerBusinessTypeBusinessInputTarget.checked = true;
      } else {
        this.CustomerBusinessTypeFarmInputTarget.checked = true;
      }
      if (po.order.truckload_order.destination_unloading_options.includes("Loading Dock")) {
        this.CustomerLoadingOptionLoadingDockInputTarget.checked = true;
      } else if (po.order.truckload_order.destination_unloading_options.includes("Forklift")) {
        this.CustomerLoadingOptionForkliftInputTarget.checked = true;
      } else if (po.order.truckload_order.destination_unloading_options.includes("Pallet Jack")) {
        this.CustomerLoadingOptionPalletJackInputTarget.checked = true;
      } else {
        this.CustomerLoadingOptionNoneInputTarget.checked = true;
      }
    }

    if (po.order && po.order.order_items[0].listing) {
      const listing = po.order.order_items[0].listing

      this.SupplierStreetInputTarget.value = listing.street_address;
      this.SupplierCityInputTarget.value = listing.city;
      this.SupplierStateInputTarget.value = listing.state;
      this.SupplierZipInputTarget.value = listing.zipcode;
    }

    // if order.present? && order.selected_truckload_rate.present?
    if (truckType && totalWeight && po.order.truckload_data) {
      if (po.order.truckload_data.truckload_order_tote_size) {
        toteSize = parseInt(po.order.truckload_data.truckload_order_tote_size);

        this.NumPalletsInputTarget.value = Math.ceil(totalWeight / toteSize);
      }
    }
  }

  onPickupDateTypeChange(e) {
    if (e.target.value === "ASAP") {
      this.PickupDateSelectionTarget.classList.add("hidden")
      this.PickupDateInputTarget.value = "ASAP"
    } else {
      this.PickupDateSelectionTarget.classList.remove("hidden")
      this.PickupDateInputTarget.value = this.PickupDateSelectionTarget.value
    }
  }

  onPickupDateSelectionChange(e) {
    this.PickupDateInputTarget.value = e.target.value
  }

  onBolBlindOriginTypeChange(e) {
    if (e.target.value == "yes") {
      this.BolBlindOriginDetailsContainerTarget.classList.remove("hidden");
      this.BolBlindOriginInputTarget.value = true;
    } else {
      this.BolBlindOriginDetailsContainerTarget.classList.add("hidden");
      this.BolBlindOriginInputTarget.value = false;
    }
  }

  onBolBlindDestinationTypeChange(e) {
    if (e.target.value == "yes") {
      this.BolBlindDestinationDetailsContainerTarget.classList.remove("hidden");
      this.BolBlindDestinationInputTarget.value = true;
    } else {
      this.BolBlindDestinationDetailsContainerTarget.classList.add("hidden");
      this.BolBlindDestinationInputTarget.value = false;
    }
  }

  onSubmit(e) {
    const purchaseOrderIds = JSON.parse(this.PurchaseOrderIdsInputTarget.value);
    if (purchaseOrderIds.length > 1 && !this.SelectedShippingOptionTarget.value) {
      e.preventDefault();
      this.ShippingOptionValidationMessageTarget.classList.remove("hidden");
    } else {
      this.ShippingOptionValidationMessageTarget.classList.add("hidden");
    }
  }
}
